import { render } from "./ProgressWidget.vue?vue&type=template&id=da435d20"
import script from "./ProgressWidget.vue?vue&type=script&lang=js"
export * from "./ProgressWidget.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__